// API_BASE_URL se resuelve en runtime desde /config.json (ver cargarApiBaseUrl
// más abajo, llamado una sola vez en index.js antes de renderizar la app) en
// vez de venir hardcodeado del build (.env.production / REACT_APP_API_NOMBRE).
// Así el MISMO build sirve para todas las franquicias: cada una tiene su
// propio config.json en su carpeta `build` en el servidor, que el deploy
// nunca pisa — a diferencia del JS, que sí se reemplaza en cada deploy.
//
// REACT_APP_API_BASE_URL (horneado en el build) SOLO se usa como fallback en
// desarrollo (`npm start`). En producción NO se usa como fallback a propósito:
// si config.json faltara o estuviera roto en el server de una franquicia, caer
// al valor horneado significaría pegarle en silencio a la API de la franquicia
// con la que se compiló el build (ej. gridoalem) — exactamente lo que este
// mecanismo existe para evitar. Mejor que falle visible (URL vacía → todas las
// llamadas fallan) a que mezcle datos de otra franquicia sin que se note.
let API_BASE_URL = process.env.NODE_ENV === 'production' ? '' : (process.env.REACT_APP_API_BASE_URL || '');

async function cargarApiBaseUrl() {
  try {
    // El query param con timestamp es a propósito: `cache: 'no-store'` solo
    // le pide al NAVEGADOR que no cachee, pero un proxy/CDN entre el
    // navegador y el server puede seguir devolviendo una copia vieja de
    // config.json para la misma URL exacta. Cambiar la URL en cada carga
    // evita cualquier cache intermedio, sin depender de qué headers mande
    // el servidor.
    const res = await fetch(`${process.env.PUBLIC_URL}/config.json?_=${Date.now()}`, { cache: 'no-store' });
    if (!res.ok) throw new Error(`config.json respondió ${res.status}`);
    const data = await res.json();
    if (!data || !data.apiBaseUrl) throw new Error('config.json sin apiBaseUrl');
    API_BASE_URL = data.apiBaseUrl;
  } catch (e) {
    if (process.env.NODE_ENV === 'production') {
      console.error('No se pudo cargar /config.json — la app no sabe a qué API conectarse.', e);
    }
    // En desarrollo seguimos con el fallback de REACT_APP_API_BASE_URL de arriba.
  }
}

const LOGIN = "auth/login.php";
const LOGOUT = "auth/logout.php";
const SIGIN = "auth/register.php";
const USERLIST = "usuarios/userlist.php";
const USERACTUALIZAR = "usuarios/usuarioactualizar.php";
const USUARIOGET = "usuarios/usuarioget.php";
const USUARIOALTA = "usuarios/usuarioalta.php";
const USUARIOFORMDATA = "usuarios/usuarioformdata.php";

const USUARIOACCION = "auditoria/usuarioaccion.php";
const USUARIOACCIONLISTAR = "usuarios/usuarioaccioneslistar.php";

const FECHAHORA = "util/getfechahora.php";
const LOGERRORINSERT = "auditoria/logerror.php";
const ERRORESLIST = "auditoria/erroreslistar.php";

const AUDITORIA = "auditoria/auditoria.php";
const AUDITORIALISTAR = "auditoria/auditorialistar.php";

const FACTURACION_GET = "facturacion/facturacionget.php";
const FACTURACION_SAVE = "facturacion/facturacionguardar.php";
const FACTURACION_TEST = "facturacion/facturaciontest.php";
const FACTURACION_PROXNUM = "facturacion/facturacionproxnum.php";
const FACTURACION_CERT_GUARDAR = "facturacion/facturacioncertguardar.php";
const FACTURACION_EMITIR = "facturacion/facturacionemitir.php";

const TIEMPOEXPIRACIONCOOKIEENMINUTOS = 300; // 5 horas

const VERIFICARVENCIMIENTO = "util/verificar_vencimiento.php";
const PAGO_LICENCIA_SUBIR = "licencia/pago_licencia_subir.php";
const PAGO_LICENCIA_LISTAR = "licencia/pago_licencia_listar.php";

const GRIDO_LOCALES = "grido/gridolocales.php";
const GRIDO_COMPETIDORES = "grido/competidores.php";
const GRIDO_GEOCODIFICAR = "grido/geocodificar.php";
const GRIDO_RESENAS = "grido/resenas.php";
const GRIDO_POBLACION = "grido/poblacion.php";

const REGISTRO_FORMDATA = "registros/registroformdata.php";
const REGISTRO_ALTA = "registros/registroalta.php";
const REGISTROS_LISTAR = "registros/registroslistar.php";
const REGISTRO_GET = "registros/registroget.php";
const REGISTRO_ACTUALIZAR = "registros/registroactualizar.php";
const REGISTRO_ANULAR = "registros/registroanular.php";
const REGISTROS_POR_PRODUCTO = "registros/registrosporproducto.php";
const REGISTROS_SUCURSALES = "registros/registrossucursales.php";

const PRODUCTO_FORMDATA = "productos/productoformdata.php";
const PRODUCTOS_LISTAR = "productos/productoslistar.php";
const PRODUCTO_GET = "productos/productoget.php";
const PRODUCTO_ALTA = "productos/productoalta.php";
const PRODUCTO_ACTUALIZAR = "productos/productoactualizar.php";
const PRODUCTO_ELIMINAR = "productos/productoeliminar.php";
const PRODUCTO_REACTIVAR = "productos/productoreactivar.php";

const GRUPOS_LISTAR = "grupos/gruposlistar.php";
const GRUPO_GET = "grupos/grupoget.php";
const GRUPO_ALTA = "grupos/grupoalta.php";
const GRUPO_ACTUALIZAR = "grupos/grupoactualizar.php";
const GRUPO_ELIMINAR = "grupos/grupoeliminar.php";

const SUCURSAL_FORMDATA = "sucursales/sucursalformdata.php";
const SUCURSALES_LISTAR = "sucursales/sucursaleslistar.php";
const SUCURSAL_GET = "sucursales/sucursalget.php";
const SUCURSAL_ALTA = "sucursales/sucursalalta.php";
const SUCURSAL_ACTUALIZAR = "sucursales/sucursalactualizar.php";
const SUCURSAL_ELIMINAR = "sucursales/sucursaleliminar.php";
const SUCURSAL_REACTIVAR = "sucursales/sucursalreactivar.php";
const SUCURSAL_USUARIOS = "sucursales/sucursalusuarios.php";

const IMPRESION_SUCURSALES = "impresion/impresionsucursales.php";
const IMPRESION_SUCURSAL_GUARDAR = "impresion/impresionsucursalguardar.php";
const IMPRESION_CERTIFICADO = "impresion/impresioncertificado.php";
const IMPRESION_FIRMAR = "impresion/impresionfirmar.php";

const ANALISIS_GET = "analisis/analisisget.php";

const MAPEO_PRECIOS_LISTAR = "mapeoprecios/mapeoprecioslistar.php";
const MAPEO_PRECIOS_ALTA = "mapeoprecios/mapeoprecioalta.php";
const MAPEO_PRECIOS_ACTUALIZAR = "mapeoprecios/mapeoprecioactualizar.php";
const MAPEO_PRECIOS_CONTRA_EXCEL = "mapeoprecios/mapeoprecioscontraexcel.php";
const MAPEO_PRECIOS_DUPLICADOS_PREVIEW = "mapeoprecios/mapeoprecioslimpiarduplicadospreview.php";
const MAPEO_PRECIOS_DUPLICADOS_APLICAR = "mapeoprecios/mapeoprecioslimpiarduplicadosaplicar.php";

const PRECIOS_SUBIR = "precios/preciossubir.php";
const PRECIOS_PREVISUALIZAR = "precios/preciosprevisualizar.php";
const PRECIOS_APLICAR = "precios/preciosaplicar.php";

const TURNO_FORMDATA = "turnos/turnoformdata.php";
const TURNO_ABRIR = "turnos/turnoabrir.php";
const TURNO_ACTUAL = "turnos/turnoactual.php";
const TURNOS_LISTAR = "turnos/turnoslistar.php";
const TURNO_GET = "turnos/turnoget.php";
const TURNO_CERRAR = "turnos/turnocerrar.php";

const CHECKLIST_TAREAS_LISTAR = "checklist/checklisttareaslistar.php";
const CHECKLIST_TAREA_ALTA = "checklist/checklisttareaalta.php";
const CHECKLIST_TAREA_ACTUALIZAR = "checklist/checklisttareaactualizar.php";
const CHECKLIST_ASIGNACION_TOGGLE = "checklist/checklistasignaciontoggle.php";
const CHECKLIST_TAREA_CLONAR = "checklist/checklisttareaclonar.php";
const CHECKLIST_TURNO = "checklist/checklistturno.php";
const CHECKLIST_MARCAR = "checklist/checklistmarcar.php";

export {
  API_BASE_URL, cargarApiBaseUrl, LOGIN, LOGOUT, SIGIN, USERLIST, USERACTUALIZAR, USUARIOGET, USUARIOALTA, USUARIOFORMDATA,
  USUARIOACCION, USUARIOACCIONLISTAR, ERRORESLIST,
  FECHAHORA, LOGERRORINSERT, AUDITORIA, AUDITORIALISTAR, TIEMPOEXPIRACIONCOOKIEENMINUTOS,
  FACTURACION_GET, FACTURACION_SAVE, FACTURACION_TEST, FACTURACION_PROXNUM, FACTURACION_CERT_GUARDAR, FACTURACION_EMITIR,
  VERIFICARVENCIMIENTO, PAGO_LICENCIA_SUBIR, PAGO_LICENCIA_LISTAR,
  GRIDO_LOCALES, GRIDO_COMPETIDORES, GRIDO_GEOCODIFICAR, GRIDO_RESENAS, GRIDO_POBLACION,
  REGISTRO_FORMDATA, REGISTRO_ALTA, REGISTROS_LISTAR, REGISTRO_GET, REGISTRO_ACTUALIZAR, REGISTRO_ANULAR, REGISTROS_POR_PRODUCTO, REGISTROS_SUCURSALES,
  PRODUCTO_FORMDATA, PRODUCTOS_LISTAR, PRODUCTO_GET, PRODUCTO_ALTA, PRODUCTO_ACTUALIZAR, PRODUCTO_ELIMINAR, PRODUCTO_REACTIVAR,
  GRUPOS_LISTAR, GRUPO_GET, GRUPO_ALTA, GRUPO_ACTUALIZAR, GRUPO_ELIMINAR,
  SUCURSAL_FORMDATA, SUCURSALES_LISTAR, SUCURSAL_GET, SUCURSAL_ALTA, SUCURSAL_ACTUALIZAR, SUCURSAL_ELIMINAR, SUCURSAL_REACTIVAR, SUCURSAL_USUARIOS,
  TURNO_FORMDATA, TURNO_ABRIR, TURNO_ACTUAL, TURNOS_LISTAR, TURNO_GET, TURNO_CERRAR,
  CHECKLIST_TAREAS_LISTAR, CHECKLIST_TAREA_ALTA, CHECKLIST_TAREA_ACTUALIZAR, CHECKLIST_ASIGNACION_TOGGLE, CHECKLIST_TAREA_CLONAR, CHECKLIST_TURNO, CHECKLIST_MARCAR,
  IMPRESION_SUCURSALES, IMPRESION_SUCURSAL_GUARDAR, IMPRESION_CERTIFICADO, IMPRESION_FIRMAR,
  ANALISIS_GET,
  PRECIOS_SUBIR, PRECIOS_PREVISUALIZAR, PRECIOS_APLICAR,
  MAPEO_PRECIOS_LISTAR, MAPEO_PRECIOS_ALTA, MAPEO_PRECIOS_ACTUALIZAR, MAPEO_PRECIOS_CONTRA_EXCEL,
  MAPEO_PRECIOS_DUPLICADOS_PREVIEW, MAPEO_PRECIOS_DUPLICADOS_APLICAR,
};
